import React, { useEffect, useState, isValidElement, Children } from 'react';
import { AxiosError } from 'axios';
import Header from '../../top/components/Header';
import Footer from '../../top/components/Footer';
import type { FlatRateAgreement } from "../../flatRates/types";
import getCustomer from "@/features/customer/shared/api/getCustomer"

type LayoutProps = {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({children}) => {
  const [flatRateAgreement, setFlatRateAgreement] = useState<FlatRateAgreement>();
  const [requestType, setRequestType] = useState<string>();
  const [creditUrl, setCreditUrl] = useState<string>();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getCustomer();
        setFlatRateAgreement(response.data.flatRateAgreement);
        setRequestType(response.data.requestType);
        setCreditUrl(response.data.creditUrl);
      } catch (error: unknown) {
        if(error instanceof AxiosError) {
          console.error(error.message);
        }
      }
    }

    fetchData();
  }, [])

  type ChildProps = {
    flatRateAgreement?: FlatRateAgreement;
    requestType?: string;
    creditUrl?: string;
  };
  
  const childrenWithProps = Children.map(children, child => {
    if (isValidElement(child)) {
      return React.cloneElement(child as React.ReactElement<ChildProps>, {
        flatRateAgreement,
        requestType,
        creditUrl
      });
    }
    return child;
  });

  return (
    <React.Fragment>
      <Header flatRateAgreement={flatRateAgreement} requestType={requestType} creditUrl={creditUrl} />
        {childrenWithProps}
      <Footer />
    </React.Fragment>
  )
}

export default Layout;